import React from "react";

import { SOIL_SIGHT_FLOW_ROUTES } from "consts";

import { ScenarioLandingPage } from "pages/app/scenario-landing/ScenarioLandingPage";
import { useSoilSightFlowRedirect } from "pages/app/scenario-onboarding/hooks/useSoilSightFlowRedirect";

export const ScenarioLandingGate = () => {
  const { isHolding } = useSoilSightFlowRedirect(SOIL_SIGHT_FLOW_ROUTES.landing);

  if (isHolding) {
    return null;
  }

  return <ScenarioLandingPage />;
};

export default ScenarioLandingGate;
